var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "block",
    height: "41px",
    width: "27px",
    viewBox: "0 0 27 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.0, 29.0)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.04,
    cx: 10.5,
    cy: 5.80029008,
    rx: 10.5,
    ry: 5.25002273
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.04,
    cx: 10.5,
    cy: 5.80029008,
    rx: 10.5,
    ry: 5.25002273
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.04,
    cx: 10.5,
    cy: 5.80029008,
    rx: 9.5,
    ry: 4.77275007
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.04,
    cx: 10.5,
    cy: 5.80029008,
    rx: 8.5,
    ry: 4.29549936
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.04,
    cx: 10.5,
    cy: 5.80029008,
    rx: 7.5,
    ry: 3.81822308
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.04,
    cx: 10.5,
    cy: 5.80029008,
    rx: 6.5,
    ry: 3.34094679
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.04,
    cx: 10.5,
    cy: 5.80029008,
    rx: 5.5,
    ry: 2.86367051
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.04,
    cx: 10.5,
    cy: 5.80029008,
    rx: 4.5,
    ry: 2.38636864
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.0, 7.0)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0, 8.0)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    opacity: 0.25,
    cx: 5.5,
    cy: 5.5,
    r: 5.4999962
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 5.5,
    cy: 5.5,
    r: 5.4999962
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.70697641.svg";
export { ForwardRef as ReactComponent };